import * as yup from "yup";
import { AnalisisLaboratorioSchema } from "../data/AnalisisLaboratorioSchema";
import { RepresentanteLegalSchema } from "../data/RepresentanteLegalSchema";
import { MonitoreoAireSchema } from "../data/MonitoreoAireSchema";
import { MedicionSchema } from "../data/MedicionSchema";
import { RepresentanteTecnicoSchema } from "../data/RepresentanteTecnicoSchema";
import { CertificadoAptitudAmbientalSchema } from "../data/CertificadoAptitudAmbientalSchema";
import { SeguroAmbientalSchema } from "../data/SeguroAmbientalSchema";
import { OperacionUnitariaSchema } from "../data/OperacionUnitariaSchema";
import { ProductoSchema } from "../data/ProductoSchema";
import { DuctoSchema } from "../data/DuctoSchema";
import { MedicionCaudalMasicoSchema } from "../data/MedicionCaudalMasicoSchema";
import { ResiduoPeligrosoSchema } from "../data/ResiduoPeligrosoSchema";
import { LineaVertidoSchema } from "../data/LineaVertisoSchema";
import { ConexionRedSchema } from "../data/ConexionRedSchema";
import { AprovechamientoPluvialesSchema } from "../data/AprovechamientoPluvialesSchema";
import { ReusoProcesoSchema } from "../data/ReusoProcesoSchema";
import { TomaAguaSuperficialSchema } from "../data/TomaAguaSuperficialSchema";
import { PozoAguaSubterraneaSchema } from "../data/PozoAguaSubterraneaSchema";
import { TanqueAcopioLiquidoSchema } from "../data/TanqueAcopioLiquidoSchema";
import { AreaAcopioSolidosSchema } from "../data/AreaAcopioSolidosSchema";
import { ResiduoTratamientoSchema } from "../data/ResiduoTratamientoSchema";
import { ArchivoSchema } from "../data/ArchivoSchema";
import { ResiduoSolidoUrbanoSchema } from "../data/ResiduoSolidoUrbanoSchema";
import { ResiduoPatogenicoSchema } from "../data/ResiduoPatogenicoSchema";
import { SustanciaQuimicaSchema } from "../data/SustanciaQuimicaSchema";
import { PlantaTratamientoSchema } from "../data/PlantaTratamientoSchema";
import { TramiteSchema } from "../data/TramiteSchema";
import { TratamientoExternoSchema } from "../data/TratamientoExternoSchema";
import { RemediacionesSchema } from "../data/RemediacionesSchema";
import { CategoriaAmbiental, EstadoTramite, TipoTramite } from "./enums";
import { EmpresaSchema } from "../data/EmpresaSchema";
import { DireccionSchema } from "../data/DireccionSchema";
import { PuntoGeograficoSchema } from "../data/PuntoGeograficoSchema";
import { TelefonoRegex } from "./regex";
import { JornadaSchema } from "../data/JornadaSchema";
import { CantidadSchema } from "../data/CantidadSchema";
import { FuenteEfluenteLiquidoSchema } from "../data/FuenteEfluenteLiquidoSchema";
import { DocumentoAdjuntoSchema } from "../data/DocumentoAdjuntoSchema";

yup.addMethod(yup.array, "unique", function (message, mapper = (a) => a) {
  return this.test("unique", message, function (list) {
    return list.length === new Set(list.map(mapper)).size;
  });
});

export function nuevoItemOrdenado(list) {
  const orden = Math.max(0, ...list?.map((item) => item.orden)) + 1;
  return { orden };
}

export function crearRepresentanteLegal() {
  return RepresentanteLegalSchema.cast(undefined, { assert: false });
}

export function crearMonitoreoAire() {
  return MonitoreoAireSchema.cast(undefined, { assert: false });
}

export function crearRepresentanteTecnico() {
  return RepresentanteTecnicoSchema.cast(undefined, { assert: false });
}

export function crearCertificadoAptitudAmbiental() {
  return CertificadoAptitudAmbientalSchema.cast(undefined, { assert: false });
}

export function crearSeguroAmbiental() {
  return SeguroAmbientalSchema.cast(undefined, { assert: false });
}

export function crearOperacionUnitaria(list) {
  return OperacionUnitariaSchema.cast(nuevoItemOrdenado(list), {
    assert: false,
  });
}

export function crearProducto(list) {
  return ProductoSchema.cast(nuevoItemOrdenado(list), { assert: false });
}

export function crearLineaVertido(list) {
  return LineaVertidoSchema.cast(nuevoItemOrdenado(list), { assert: false });
}

export function crearDucto(list) {
  return DuctoSchema.cast(nuevoItemOrdenado(list), { assert: false });
}

export function crearMedicionCaudalMasico(list) {
  return MedicionCaudalMasicoSchema.cast(undefined, { assert: false });
}

export function crearConexionRedAgua() {
  return ConexionRedSchema.cast(undefined, { assert: false });
}

export function crearAprovechamientoPluviales() {
  return AprovechamientoPluvialesSchema.cast(undefined, { assert: false });
}

export function crearReusoAgua() {
  return ReusoProcesoSchema.cast(undefined, { assert: false });
}

export function crearTomaAguaSuperficial(list) {
  return TomaAguaSuperficialSchema.cast(nuevoItemOrdenado(list), {
    assert: false,
  });
}

export function crearPozoAguaSubterranea(list) {
  return PozoAguaSubterraneaSchema.cast(nuevoItemOrdenado(list), {
    assert: false,
  });
}

export function crearTanqueAcopioLiquido(list) {
  return TanqueAcopioLiquidoSchema.cast(nuevoItemOrdenado(list), {
    assert: false,
  });
}

export function crearAreaAcopioSolido(list) {
  return AreaAcopioSolidosSchema.cast(nuevoItemOrdenado(list), {
    assert: false,
  });
}

export function crearRemediaciones() {
  return RemediacionesSchema.cast(undefined, { assert: false });
}

export function crearTratamientoExterno(lsit) {
  return TratamientoExternoSchema.cast(nuevoItemOrdenado(lsit), {
    assert: false,
  });
}

export function crearResiduoTratamiento(list) {
  return ResiduoTratamientoSchema.cast(nuevoItemOrdenado(list), {
    assert: false,
  });
}

export function crearArchivo() {
  return ArchivoSchema.cast(undefined, { assert: false });
}

export function crearResiduoSolidoUrbano(list) {
  return ResiduoSolidoUrbanoSchema.cast(nuevoItemOrdenado(list), {
    assert: false,
  });
}

export function crearResiduoPatogenico(list) {
  return ResiduoPatogenicoSchema.cast(nuevoItemOrdenado(list), {
    assert: false,
  });
}

export function crearResiduoPeligroso(list) {
  return ResiduoPeligrosoSchema.cast(nuevoItemOrdenado(list), {
    assert: false,
  });
}

export function crearSustanciaQuimica(list) {
  return SustanciaQuimicaSchema.cast(nuevoItemOrdenado(list), {
    assert: false,
  });
}

export function crearPlantaTratamiento(list) {
  return PlantaTratamientoSchema.cast(nuevoItemOrdenado(list), {
    assert: false,
  });
}

export function crearAnalisisLaboratorio(list) {
  return AnalisisLaboratorioSchema.cast(nuevoItemOrdenado(list), {
    assert: false,
  });
}

export function crearMedicion() {
  return MedicionSchema.cast(undefined, { assert: false });
}

export function listarRelacionesOperacionUnitaria(
  operacionUnitaria,
  formulario,
) {
  const relaciones = {
    productosElaborados:
      formulario.values.productosElaborados?.filter((producto) => {
        return (
          producto.operacionesUnitarias.findIndex(
            (operacion) => operacion.orden === operacionUnitaria.orden,
          ) >= 0
        );
      }) || [],
    sustanciasQuimicas:
      formulario.values.sustanciasQuimicas?.filter((sustancia) => {
        return (
          sustancia.operacionesUnitarias.findIndex(
            (operacion) => operacion.orden === operacionUnitaria.orden,
          ) >= 0
        );
      }) || [],
    fuentesEfluentesLiquidos:
      formulario.values.fuentesEfluentesLiquidos?.filter((fuente) => {
        return (
          fuente.operacionesUnitarias.findIndex(
            (operacion) => operacion.orden === operacionUnitaria.orden,
          ) >= 0
        );
      }) || [],
    residuosSolidosUrbanos:
      formulario.values.residuosSolidosurbanos?.filter((residuo) => {
        return (
          residuo.operacionesUnitarias.findIndex(
            (operacion) => operacion.orden === operacionUnitaria.orden,
          ) >= 0
        );
      }) || [],
    residuosPeligrosos:
      formulario.values.residuosPatogenicos?.filter((residuo) => {
        return (
          residuo.operacionesUnitarias.findIndex(
            (operacion) => operacion.orden === operacionUnitaria.orden,
          ) >= 0
        );
      }) || [],
    residuosPatogenicos:
      formulario.values.residuosPeligrosos?.filter((residuo) => {
        return (
          residuo.operacionesUnitarias.findIndex(
            (operacion) => operacion.orden === operacionUnitaria.orden,
          ) >= 0
        );
      }) || [],
    ductos:
      formulario.values.chimeneas?.filter((ducto) => {
        return (
          ducto.operacionesUnitarias.findIndex(
            (operacion) => operacion.orden === operacionUnitaria.orden,
          ) >= 0
        );
      }) || [],
  };
  return relaciones;
}

export function filtrarTecnologias(tecnologias, seleccionadas) {
  if (!tecnologias) return [];
  return tecnologias
    .filter((tecnologia) => {
      if (seleccionadas.length > 0) {
        return (
          tecnologia.nivel >= Math.max(...seleccionadas.map((t) => t.nivel))
        );
      } else {
        return true;
      }
    })
    .filter(
      (tecnologia) =>
        seleccionadas.findIndex((t) => t.codigo === tecnologia.codigo) < 0,
    );
}

export function crearEtiquetaTecnologia(tecnologia) {
  const nivel =
    (tecnologia.nivel === 0 &&
      "Tratamiento Primario (incluye pretratamiento)") ||
    (tecnologia.nivel === 1 && "Tratamiento Secundario") ||
    (tecnologia.nivel === 2 && "Tratamiento Terciario (incluye cuaternario)") ||
    (tecnologia.nivel === 3 && "Tratamiento anexo para lodos");
  return `${tecnologia.nombre} - ${nivel}`;
}

export function filtrarContaminantes(contaminantes, mediciones) {
  return (
    (!!contaminantes && [
      ...contaminantes?.filter(
        (contaminante, indice) =>
          mediciones.findIndex(
            (medicion) => medicion.contaminante.codigo === contaminante.codigo,
          ) < 0,
      ),
    ]) ||
    []
  );
}

export function filtrarCaracteristicasPeligrosidad(
  caracteristicasPeligrosidad,
  peligrosidad,
) {
  return caracteristicasPeligrosidad?.filter(
    (caracteristica) =>
      !peligrosidad.find((value) => value.codigo === caracteristica.codigo),
  );
}

export const ACCION_ACTUALIZAR = "ACTUALIZAR";
export const ACCION_PROCESAR = "PROCESAR";

export function passThrough(value, original) {
  return value;
}

export function createCURTField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .length(11, "errors.tramite.CURT.length")
      .required("errors.tramite.CURT.required")
      .default(null);
  } else {
    return schema.optional();
  }
}

export function transformEmpresaField(value, original, context) {
  if (!!value && value !== null && context.isType(EmpresaSchema)) {
    if (
      value.CUIT === "" &&
      value.razonSocial === "" &&
      value.nombreFantasia === "" &&
      value.domicilio === null
    ) {
      return null;
    }
  }
  return value;
}

export function transformDomicilioEmpresaField(value, original, context) {
  if (!!value && value !== null && context.isType(EmpresaSchema)) {
    if (
      !!value.domicilio &&
      value.domicilio !== null &&
      value.domicilio.calle === "" &&
      value.domicilio.altura === "" &&
      value.domicilio.unidadFuncional === "" &&
      value.domicilio.codigoPostal === "" &&
      (value.domicilio.localidad === null || !value.domicilio.localidad) &&
      (value.domicilio.departamento === null ||
        !value.domicilio.departamento) &&
      (value.domicilio.provincia === null || !value.domicilio.provincia)
    ) {
      return {
        ...value,
        domicilio: null,
      };
    }
  }
  return value;
}

export function createEmpresaField([tipo, action], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .concat(EmpresaSchema)
      .required("errors.tramite.empresa.required")
      .transform(
        (action === ACCION_ACTUALIZAR && transformDomicilioEmpresaField) ||
          passThrough,
      )
      .transform(
        (action === ACCION_ACTUALIZAR && transformEmpresaField) || passThrough,
      )
      .default(null);
  } else {
    return schema.optional();
  }
}

export function createHabilitacionMunicipalField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .max(20, "errors.tramite.habilitacionMunicipal.max")
      .required("errors.tramite.habilitacionMunicipal.required")
      .default(null);
  } else {
    return schema.optional();
  }
}

export function transformDomicilioField(currentValue, original, context) {
  if (context.isType(DireccionSchema)) {
    if (
      (currentValue.calle === "" || !currentValue.calle) &&
      (currentValue.altura === "" || !currentValue.altura) &&
      (currentValue.unidadFuncional === "" || !currentValue.unidadFuncional) &&
      (currentValue.codigoPostal === "" || !currentValue.codigoPostal) &&
      (currentValue.localidad === null || !currentValue.localidad) &&
      (currentValue.departamento === null || !currentValue.departamento) &&
      (currentValue.provincia === null || !currentValue.provincia)
    ) {
      return null;
    }
  }
  return currentValue;
}

export function createDomicilioField([tipo, action], schema) {
  // if (accion === ACCION_ACTUALIZAR) {
  //   schema.transform(transformDomicilioField);
  // }
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .concat(DireccionSchema)
      .required("errors.tramite.domicilio.required")
      .transform(
        (action === ACCION_ACTUALIZAR && transformDomicilioField) ||
          passThrough,
      )
      .default(null);
  } else {
    return schema.optional();
  }
}

export function createAccesoSecundarioField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .max(150, "errors.tramite.accesoSecundario.max")
      .nullable()
      .default(null);
  } else {
    return schema.optional();
  }
}

export function createZonaEmplazamientoField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .required("errors.tramite.zonaEmplazamiento.required")
      .default(null);
  } else {
    return schema.optional();
  }
}

export function createUbicacionField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .concat(PuntoGeograficoSchema)
      .required("errors.tramite.ubicacion.required")
      .default(null);
  } else {
    return schema.optional();
  }
}

export function createCorreoElectronicoField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .email("errors.tramite.correoElectronico.regex")
      .required("errors.tramite.correoElectronico.required")
      .default(null);
  } else {
    return schema.optional();
  }
}

export function createTelefonoField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .matches(TelefonoRegex, "errors.tramite.telefono.regex")
      .required("errors.tramite.telefono.required")
      .default(null);
  } else {
    return schema.optional();
  }
}

export function createWebField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.url("errors.tramite.web.regex").nullable().default(null);
  } else {
    return schema.optional();
  }
}

export function transformRepresentanteLegalField(value, originalVaue, context) {
  if (!!value && value !== null && context.isType(value)) {
    return value.nombre === "" &&
      value.documento === "" &&
      value.cargo === "" &&
      value.telefono === "" &&
      value.correoElectronico === ""
      ? null
      : value;
  }
  return value;
}

export function createRepresentanteLegalField([tipo, action], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .concat(RepresentanteLegalSchema)
      .typeError("errors.tramite.representanteLegal.required")
      .required("errors.tramite.representanteLegal.required")
      .transform(
        (action === ACCION_ACTUALIZAR && transformRepresentanteLegalField) ||
          passThrough,
      )
      .default(null);
  } else {
    return schema.optional().default(undefined);
  }
}

export function transformRepresentanteTecnicoField(value, original, context) {
  if (!!value && value !== null && context.isType(value)) {
    if (
      value.nombre === "" &&
      value.documento === "" &&
      value.cargo === "" &&
      value.telefono === "" &&
      value.correoElectronico === "" &&
      (value.matricula === null ||
        (value.matricula.ente === "" && value.matricula.numero === ""))
    ) {
      return null;
    }
  }
  return value;
}

export function createRepresentanteTecnicoField([tipo, action], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .concat(RepresentanteTecnicoSchema)
      .typeError("errors.tramite.representanteTecnico.required")
      .required("errors.tramite.representanteTecnico.required")
      .transform(
        (action === ACCION_ACTUALIZAR && transformRepresentanteTecnicoField) ||
          passThrough,
      )
      .default(null);
  } else {
    return schema.optional().strip();
  }
}

export function createActividadPrincipalField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .required("errors.tramite.actividadPrincipal.required")
      .default(null);
  } else {
    return schema.optional().nullable();
  }
}

export function createActividadSecundariaField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.nullable().default(null);
  } else {
    return schema.optional().nullable().default(null);
  }
}

export function createDescripcionActividadField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .nonNullable("errors.tramite.descripcionActividad.nonNullable")
      .max(1024, "errors.tramite.descripcionActividad.max")
      .required("errors.tramite.descripcionActividad.required");
  } else {
    return schema.optional();
  }
}

export function createConEfluentesLiquidosField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conEfluentesLiquidos.required");
  } else {
    return schema.optional();
  }
}

export function createConResiduosSolidosUrbanosField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conResiduosSolidosUrbanos.required");
  } else {
    return schema.optional();
  }
}

export function createConResiduosPeligrososField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conResiduosPeligrosos.required");
  } else {
    return schema.optional();
  }
}

export function createConResiduosPatogenicosField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conResiduosPatogenicos.required");
  } else {
    return schema.optional();
  }
}

export function createConEmisionesGaseosasField([tipo, action], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .required("errors.tramite.conEmisionesGaseosas.required")
      .default(false);
  } else {
    return schema.optional();
  }
}

export function createConEquiposPCBField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conEquiposPCB.required");
  } else {
    return schema.optional();
  }
}

export function createCategoriaAmbiental([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.categoriaAmbiental.required");
  } else {
    return schema.optional();
  }
}

export function createNivelComplejidadAmbiental(
  [tipo, categoriaAmbiental],
  schema,
) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (categoriaAmbiental?.codigo === CategoriaAmbiental.RCI) {
    return schema
      .transform((value, original) => (original === "" ? null : original))
      .nullable();
  } else {
    return schema
      .typeError("errors.tramite.nivelComplejidadAmbiental.type")
      .moreThan(0, "errors.tramite.nivelComplejidadAmbiental.moreThan")
      .lessThan(90, "errors.tramite.nivelComplejidadAmbiental.lessThan")
      .required("errors.tramite.nivelComplejidadAmbiental.required");
  }
}

export function createConRiesgoExplosionFiel([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conRiesgoExplosion.required");
  } else {
    return schema.optional();
  }
}

export function createConRiesgoIncendioField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conRiesgoIncendio.required");
  } else {
    return schema.optional();
  }
}

export function createConRiesgoRuidosField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conRiesgoRuidos.required");
  } else {
    return schema.optional();
  }
}

export function createConRiesgoSustanciasQuimicasField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required(
      "errors.tramite.conRiesgoSustanciasQuimicas.required",
    );
  } else {
    return schema.optional();
  }
}

export function createConSitiosContaminadosField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conSitiosContaminados.required");
  } else {
    return schema.optional();
  }
}

export function createConFreatimetrosField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conFreatimetros.required");
  } else {
    return schema.optional();
  }
}

export function createConRemediacionesActivasField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conRemediacionesActivas.required");
  } else {
    return schema.optional();
  }
}

export function createRemediacionesField(
  [tipo, conRemediacionesActivas],
  schema,
) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (conRemediacionesActivas) {
    return schema
      .concat(RemediacionesSchema)
      .required("errors.tramite.remediaciones.required");
  } else {
    return schema.nullable().default(null);
  }
}

export function createConCertificadoAptitudAmbientalField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required(
      "errors.tramite.conCertificadoAptitudAmbiental.required",
    );
  } else {
    return schema.optional();
  }
}

export function createConTramiteCertificadoAptitudAmbientalField(
  [tipo],
  schema,
) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .default(false)
      .required("errors.tramite.conTramiteCertificadoAptitudAmbiental");
  } else {
    return schema.optional();
  }
}

export function transformCertificadoAptitudAmbientalField(
  value,
  original,
  context,
) {
  if (
    !!value &&
    value !== null &&
    context.isType(CertificadoAptitudAmbientalSchema)
  ) {
    if (value.numero === "" && value.disposicion === "") {
      return null;
    }
  }
  return value;
}

export function createCertificadoAptitudAmbientalField(
  [tipo, conCertificadoAptitudAmbiental, action],
  schema,
) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (conCertificadoAptitudAmbiental) {
    return schema
      .concat(CertificadoAptitudAmbientalSchema)
      .required("errors.tramite.certificadoAptitudAmbiental.required")
      .transform(
        (action === ACCION_ACTUALIZAR &&
          transformCertificadoAptitudAmbientalField) ||
          passThrough,
      )
      .default(CertificadoAptitudAmbientalSchema.cast({}, { assert: false }));
  } else {
    return schema.nullable().default(null);
  }
}

export function createConCertificadoISO14001Field([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conCertificadoISO14001.required");
  } else {
    return schema.optional();
  }
}

export function createConSeguroAmbientalField([tipo], schema) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conSeguroAmbiental.required");
  } else {
    return schema.optional();
  }
}

export function transformSeguroAmbientalField(value, original, context) {
  if (!!value && value !== null && context.isType(value)) {
    if (
      value.poliza === "" &&
      value.aseguradora === "" &&
      value.importe === 0 &&
      value.vencimiento === null
    ) {
      return null;
    }
  }
  return value;
}

export function createSeguroAmbientalField(
  [tipo, conSeguroAmbiental, action],
  schema,
) {
  if ([TipoTramite.DJE, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional().strip();
  if (conSeguroAmbiental) {
    return schema
      .concat(SeguroAmbientalSchema)
      .required("errors.tramite.seguroAmbiental.required")
      .transform(
        (action === ACCION_ACTUALIZAR && transformSeguroAmbientalField) ||
          passThrough,
      )
      .default(null);
  } else {
    return schema.nullable().default(null);
  }
}

export function createConEstacionalidadField([tipo], schema) {
  if ([TipoTramite.DJG, TipoTramite.DJA].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conEstacionalidad").default(false);
  } else {
    return schema.optional();
  }
}

export function createMesesProduccionField([tipo, conEstacionalidad], schema) {
  if ([TipoTramite.DJG, TipoTramite.DJA].indexOf(tipo.codigo) < 0) {
    return schema.optional();
  } else {
    if (conEstacionalidad) {
      return schema
        .max(11, "errors.tramite.mesesProduccion.max")
        .required("errors.tramite.mesesProduccion.required");
    } else {
      return schema
        .length(12, "errors.tramite.mesesProduccion.length")
        .required("errors.tramite.mesesProduccion.required");
    }
  }
}

export function createOperacionesUnitariasField([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .of(OperacionUnitariaSchema)
      .min(1, "errors.tramite.operacionesUnitarias.min")
      .required("errors.tramite.operacionesUnitarias.required");
  } else {
    return schema.optional();
  }
}

export function createProductosElaboradosField(
  [tipo, actividadPrincipal],
  schema,
) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    if (!actividadPrincipal?.conProduccion) {
      return schema
        .of(ProductoSchema)
        .min(0, "errors.tramite.productosElaborados.min")
        .required("errors.tramite.productosElaborados.required")
        .default([]);
    } else {
      return schema
        .of(ProductoSchema)
        .min(1, "errors.tramite.productosElaborados.min")
        .required("errors.tramite.productosElaborados.required")
        .default([]);
    }
  } else {
    return schema.optional();
  }
}

export function createConQuimicosAuxiliaresField([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conQuimicosAuxiliares.required");
  } else {
    return schema.optional();
  }
}

export function createConQuimicosProduccion([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conQuimicosProduccion.required");
  } else {
    return schema.optional();
  }
}

export function createProcesoProductivoField([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .max(1024, "errors.tramite.procesoProductivo.max")
      .required("errors.tramite.procesoProductivo.required");
  } else {
    return schema.optional();
  }
}

export function createSustanciasQuimicasField([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .of(SustanciaQuimicaSchema)
      .when(("conQuimicosAuxiliares", "conQuimicosProduccion"), {
        is: true,
        then: (schema) =>
          schema.min(1, "errors.tramite.sustanciasQuimicas.min"),
        otherwise: (schema) => schema,
      })
      .required("errors.tramite.sustanciasQuimicas.required");
  } else {
    return schema.optional();
  }
}

export function createPersonalField([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .typeError("errors.tramite.personal.type")
      .min(1, "errors.tramite.personal.min")
      .required("errors.tramite.personal.required");
  } else {
    return schema.optional();
  }
}

export function createRegimenLaboralField([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .of(JornadaSchema)
      .min(1, "errors.tramite.regimenLaboral.min")
      .required("errors.tramite.regimenLaboral.required");
  } else {
    return schema.optional();
  }
}

export function createSuperficieTotalField([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .concat(CantidadSchema)
      .test(
        "magnitud.min",
        "errors.cantidad.magnitud.min",
        (value, context) => {
          return value?.magnitud > 0;
        },
      )
      .test(
        "moreThan",
        "errors.tramite.superficieTotal.moreThan",
        (value, context) =>
          value.magnitud >= context?.parent.superficieProduccion?.magnitud,
      )
      .required("errors.tramite.superficieTotal.required");
  } else {
    return schema.optional();
  }
}

export function createSuperficieProduccionField([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .concat(CantidadSchema)
      .test(
        "magnitud.min",
        "errors.cantidad.magnitud.min",
        (value, context) => {
          return value?.magnitud > 0;
        },
      )
      .test(
        "lessThan",
        "errors.tramite.superficieProduccion.lessThan",
        (value, context) =>
          value.magnitud <= context?.parent.superficieTotal?.magnitud,
      )
      .required("errors.tramite.superficieProduccion.required");
  } else {
    return schema.optional();
  }
}

export function createConConexionCloacasField([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conConexionCloacas.required");
  } else {
    return schema.optional();
  }
}

export function createConPozoAbsorbente([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conPozoAbsorbente.required");
  } else {
    return schema.optional();
  }
}

export function createConsumoElectricidadField([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .concat(CantidadSchema)
      .typeError("errors.tramite.consumoElectricidad.type")
      .test(
        "magnitud.min",
        "errors.cantidad.magnitud.min",
        (value, context) => {
          return value?.magnitud > 0;
        },
      )
      .required("errors.tramite.consumoElectricidad.required");
  } else {
    return schema.optional();
  }
}

export function createConsumoGasNaturalField([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .concat(CantidadSchema)
      .typeError("errors.tramite.consumoGasNatural.type")
      .required("errors.tramite.consumoGasNatural.required")
      .default({ magnitud: 0, unidad: { codigo: "NM3" } });
  } else {
    return schema.optional().nullable();
  }
}

export function createPotenciaActivaField([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .concat(CantidadSchema)
      .test(
        "magnitud.min",
        "errors.cantidad.magnitud.min",
        (value, context) => {
          return value?.magnitud > 0;
        },
      )
      .typeError("errors.tramite.potenciaActiva.type")
      .required("errors.tramite.potenciaActiva.required");
  } else {
    return schema.optional();
  }
}

export function createConEnergiaAlternativaField([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conEnergiaAlternativa.required");
  } else {
    return schema.optional();
  }
}

export function transformFuenteEnergiaAlternativaField(
  value,
  original,
  context,
) {
  if (!!value && value !== null) {
    if (value === "") {
      return null;
    }
  }
  return value;
}

export function createFuenteEnergiaAlternativaField(
  [tipo, conEnergiaAlternativa, action],
  schema,
) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (conEnergiaAlternativa) {
    return schema
      .max(100, "errors.tramite.fuenteEnergiaAlternativa.max")
      .required("errors.tramite.fuenteEnergiaAlternativa.required")
      .transform(
        (action === ACCION_ACTUALIZAR &&
          transformFuenteEnergiaAlternativaField) ||
          passThrough,
      )
      .default("");
  } else {
    return schema.nullable().default(null);
  }
}

export function transformConsumoEnergiaAlternativaField(
  value,
  original,
  context,
) {
  if (!!value && value !== null && context.isType(CantidadSchema)) {
    if (value.magnitud === 0 && (!value.unidad || value.unidad === null)) {
      return null;
    }
  }
  return value;
}

export function createConsumoEnergiaAlternativaField(
  [tipo, conEnergiaAlternativa, action],
  schema,
) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (conEnergiaAlternativa) {
    return schema
      .concat(CantidadSchema)
      .test(
        "magnitud.min",
        "errors.cantidad.magnitud.min",
        (value, context) => {
          return value?.magnitud > 0;
        },
      )
      .typeError("errors.tramite.consumoEnergiaAlternativa.required")
      .required("errors.tramite.consumoEnergiaAlternativa.required")
      .transform(
        (action === ACCION_ACTUALIZAR &&
          transformConsumoEnergiaAlternativaField) ||
          passThrough,
      );
  } else {
    return schema.nullable().default(null);
  }
}

export function createConCaptacionAguaRedField([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conCaptacionAguaRed.required");
  } else {
    return schema.optional();
  }
}

export function createConCaptacionAguaSubterraneaField([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required(
      "errors.tramite.conCaptacionAguaSubterranea.required",
    );
  } else {
    return schema.optional();
  }
}

export function createConCaptacionAguaSuperficialField([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required(
      "errors.tramite.conCaptacionAguaSuperficial.required",
    );
  } else {
    return schema.optional();
  }
}

export function createConReusoAguaField([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required("errors.tramite.conReusoAgua.required");
  } else {
    return schema.optional();
  }
}

export function createConAprovechamientoPluvialesField([tipo], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema.required(
      "errors.tramite.conAprovechamientoPluviales.required",
    );
  } else {
    return schema.optional();
  }
}

export function transformConexionRedAguaField(value, original, context) {
  if (!!value && value !== null && context.isType(ConexionRedSchema)) {
    if (
      (value.caudalMedio === null ||
        (value.caudalMedio.magnitud === 0 &&
          !value.caudalMedio.unidad?.texto)) &&
      (value.caudalPico === null ||
        (value.caudalPico.magnitud === 0 && !value.caudalMedio.unidad.texto)) &&
      value.prestador === null
    ) {
      return null;
    }
  }
  return value;
}

export function createConexionRedAguaField(
  [tipo, conCaptacionAguaRed, action],
  schema,
) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (conCaptacionAguaRed) {
    return schema
      .concat(ConexionRedSchema)
      .typeError("errors.tramite.conexionRedAgua.required")
      .required("errors.tramite.conexionRedAgua.required")
      .transform(
        (action === ACCION_ACTUALIZAR && transformConexionRedAguaField) ||
          passThrough,
      );
  } else {
    return schema.concat(ConexionRedSchema).nullable().default(null);
  }
}

export function createPozosAguaSubterraneaField(
  [tipo, conCaptacionAguaSubterranea],
  schema,
) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (conCaptacionAguaSubterranea) {
    return schema
      .of(PozoAguaSubterraneaSchema)
      .min(1, "errors.tramite.pozosAguaSubterranea.min")
      .required("errors.tramite.pozosAguaSubterranea.required");
  } else {
    return schema
      .of(PozoAguaSubterraneaSchema)
      .min(0)
      .required("errors.tramite.pozosAguaSubterranea.required");
  }
}

export function createTomasAguaSuperficialField(
  [tipo, conCaptacionAguaSuperficial],
  schema,
) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (conCaptacionAguaSuperficial) {
    return schema
      .of(TomaAguaSuperficialSchema)
      .min(1, "errors.tramite.tomasAguaSuperficial.min")
      .required("errors.tramite.tomasAguaSuperficial.required")
      .default([]);
  } else {
    return schema
      .of(TomaAguaSuperficialSchema)
      .min(0)
      .required("errors.tramite.tomasAguaSuperficial.required")
      .default([]);
  }
}

export function transformAprovechamientoPluviales(value, original, context) {
  if (
    !!value &&
    value !== null &&
    context.isType(AprovechamientoPluvialesSchema)
  ) {
    if (
      value.volumenTanque.magnitud === 0 &&
      (!value.volumenTanque.unidad ||
        value.volumenTanque.unidad === null ||
        !value.volumenTanque.unidad?.texto) &&
      value.aprovechamiento.magnitud === 0 &&
      (!value.aprovechamiento.unidad ||
        value.aprovechamiento.unidad === null ||
        !value.aprovechamiento.unidad.texto)
    ) {
      return null;
    }
  }
  return value;
}

export function createAprovechamientoPluvialesField(
  [tipo, conAprovechamientoPluviales, action],
  schema,
) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (conAprovechamientoPluviales) {
    return schema
      .concat(AprovechamientoPluvialesSchema)
      .typeError("errors.tramite.aprovechamientoPluviales.required")
      .required("errors.tramite.aprovechamientoPluviales.required")
      .transform(
        (action === ACCION_ACTUALIZAR && transformAprovechamientoPluviales) ||
          passThrough,
      );
  } else {
    return schema
      .concat(AprovechamientoPluvialesSchema)
      .nullable()
      .default(null);
  }
}

export function transformReusoAguaField(value, original, context) {
  if (!!value && value !== null && context.isType(ReusoProcesoSchema)) {
    if (
      value.volumenTanque.magnitud === 0 &&
      (!value.volumenTanque.unidad ||
        value.volumenTanque.unidad === null ||
        !value.volumenTanque.unidad?.texto) &&
      value.aprovechamiento.magnitud === 0 &&
      (!value.aprovechamiento.unidad ||
        value.aprovechamiento.unidad === null ||
        !value.aprovechamiento.unidad.texto)
    ) {
      return null;
    }
  }
  return value;
}

export function createReusoAguaField([tipo, conReusoAgua], schema) {
  if ([TipoTramite.DJA, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (conReusoAgua) {
    return schema
      .concat(ReusoProcesoSchema)
      .typeError("errors.tramite.reusoAgua.required")
      .required("errors.tramite.reusoAgua.required");
  } else {
    return schema.concat(ReusoProcesoSchema).nullable().default(null);
  }
}

export function createFuentesEfluentesLiquidosField(
  [tipo, conEfluentesLiquidos],
  schema,
) {
  if ([TipoTramite.DJEELL, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    tipo.codigo === TipoTramite.DJEELL ||
    (tipo.codigo === TipoTramite.DJG && conEfluentesLiquidos)
  ) {
    return schema
      .of(FuenteEfluenteLiquidoSchema)
      .min(1, "errors.tramite.fuentesEfluentesLiquidos.min")
      .required("errors.tramite.fuentesEfluentesLiquidos.required")
      .default([]);
  } else {
    return schema
      .of(FuenteEfluenteLiquidoSchema)
      .min(0)
      .required("errors.tramite.fuentesEfluentesLiquidos.required")
      .default([]);
  }
}

export function createTratamientoIndividualField(
  [
    tipo,
    conEfluentesLiquidos,
    actividadPrincipal,
    actividadSecundaria,
    establecimiento,
  ],
  schema,
) {
  if ([TipoTramite.DJEELL, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional().nullable();
  const actividadEsComplejoHabitacional =
    actividadPrincipal?.esComplejoHabitacional ||
    actividadSecundaria?.esComplejoHabitacional;
  const establecimientoEsComplejoHabitacional =
    establecimiento?.actividadPrincipal?.esComplejoHabitacional ||
    establecimiento?.actividadSecundaria?.esComplejoHabitacional;
  if (
    (tipo?.codigo === TipoTramite.DJG &&
      conEfluentesLiquidos &&
      actividadEsComplejoHabitacional) ||
    (tipo?.codigo === TipoTramite.DJEELL &&
      (actividadEsComplejoHabitacional ||
        establecimientoEsComplejoHabitacional))
  ) {
    return schema
      .concat(CantidadSchema)
      .test(
        "magnitud.min",
        "errors.cantidad.magnitud.min",
        (value, context) => {
          return value?.magnitud >= 0;
        },
      )
      .typeError("errors.tramite.tratamientoIndividual.required")
      .required("errors.tramite.tratamientoIndividual.required")
      .default(
        CantidadSchema.cast(
          { unidad: { codigo: "PORCENTAJE" } },
          { assert: false },
        ),
      );
  } else {
    return schema.optional().nullable().default(null);
  }
}

export function createPlantasTratamientoField(
  [tipo, conEfluentesLiquidos],
  schema,
) {
  if ([TipoTramite.DJG, TipoTramite.DJEELL].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    tipo.codigo === TipoTramite.DJEELL ||
    (tipo.codigo === TipoTramite.DJG && conEfluentesLiquidos)
  ) {
    return schema
      .of(PlantaTratamientoSchema)
      .min(0)
      .required("errors.tramite.plantasTratamiento.required")
      .default([]);
  } else {
    return schema
      .of(PlantaTratamientoSchema)
      .min(0)
      .required("errors.tramite.plantasTratamiento.required")
      .default([]);
  }
}

export function createCaracterizacionEfluenteCrudoField(
  [tipo, conEfluentesLiquidos, plantasTratamiento],
  schema,
) {
  if ([TipoTramite.DJG, TipoTramite.DJEELL].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    tipo.codigo === TipoTramite.DJEELL ||
    (tipo.codigo === TipoTramite.DJG && conEfluentesLiquidos)
  ) {
    const tecnologias = [];
    plantasTratamiento.forEach((planta) =>
      tecnologias.push(...planta.tecnologias),
    );
    if (tecnologias.filter((tecnologia) => tecnologia.nivel >= 1).length > 0) {
      return schema
        .of(MedicionSchema)
        .required("errors.tramite.caracterizacionEfluenteCrudo.required")
        .test(
          "DQORequerido",
          "errors.tramite.caracterizacionEfluenteCrudo.DQORequired",
          (value) =>
            !!value &&
            value instanceof Array &&
            !!value.find(
              (medicion) => "DQO" === medicion?.contaminante?.codigo,
            ),
        )
        .test(
          "DBORequerido",
          "errors.tramite.caracterizacionEfluenteCrudo.DBORequired",
          (value) =>
            !!value &&
            value instanceof Array &&
            !!value.find(
              (medicion) => "DBO" === medicion?.contaminante?.codigo,
            ),
        )
        .default([]);
    }
    return schema
      .of(MedicionSchema)
      .min(0)
      .required("errors.tramite.caracterizacionEfluenteCrudo.required")
      .default([]);
  }
  return schema
    .of(MedicionSchema)
    .min(0)
    .required("errors.tramite.caracterizacionEfluenteCrudo.required")
    .default([]);
}

export function createLineasVertidoField(
  [tipo, conEfluentesLiquidos, conTratamientoExterno],
  schema,
) {
  if ([TipoTramite.DJG, TipoTramite.DJEELL].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    ((tipo.codigo === TipoTramite.DJG && conEfluentesLiquidos) ||
      tipo.codigo === TipoTramite.DJEELL) &&
    !conTratamientoExterno
  ) {
    return schema
      .of(LineaVertidoSchema)
      .min(1, "errors.tramite.lineasVertido.min")
      .required("errors.tramite.lineasVertido.required")
      .default([]);
  } else {
    return schema
      .of(LineaVertidoSchema)
      .min(0)
      .required("errors.tramite.lineasVertido.required")
      .default([]);
  }
}

export function createConTratamientoExternoField([tipo], schema) {
  if ([TipoTramite.DJEELL, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .required("errors.tramite.conTratamientoExterno.required")
      .default(false);
  } else {
    return schema.optional();
  }
}

export function createTratamientosExternosField(
  [tipo, conEfluentesLiquidos, conTratamientoExterno],
  schema,
) {
  if ([TipoTramite.DJEELL, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    (tipo.codigo === TipoTramite.DJEELL ||
      (tipo.codigo === TipoTramite.DJG && conEfluentesLiquidos)) &&
    conTratamientoExterno
  ) {
    return schema
      .of(TratamientoExternoSchema)
      .min(1, "errors.tramite.tratamientosExternos.min")
      .required("errors.tramite.tratamientosExternos.required")
      .default([]);
  } else {
    return schema
      .of(TratamientoExternoSchema)
      .min(0)
      .required("errors.tramite.tratamientosExternos.required")
      .default([]);
  }
}

export function createReusoTratamientoField(
  [tipo, conEfluentesLiquidos],
  schema,
) {
  if ([TipoTramite.DJEELL, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional().default(undefined);
  if (
    tipo.codigo === TipoTramite.DJEELL ||
    (tipo.codigo === TipoTramite.DJG && conEfluentesLiquidos)
  ) {
    return schema
      .concat(CantidadSchema)
      .test(
        "magnitud.min",
        "errors.cantidad.magnitud.min",
        (value, context) => {
          return value?.magnitud >= 0;
        },
      )
      .typeError("errors.tramite.reusoTratamiento.required")
      .test("min", "errors.tramite.reusoTratamiento.min", (value, context) => {
        return value.magnitud <= 100;
      })
      .required("errors.tramite.reusoTratamiento.required")
      .default({ magnitud: 0, unidad: { codigo: "PORCENTAJE" } });
  } else {
    return schema.nullable().nullable().default(null);
  }
}

export function createResiduosTratamientoField(
  [tipo, conEfluentesLiquidos, plantasTratamiento],
  schema,
) {
  if ([TipoTramite.DJEELL, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    if (
      (tipo.codigo === TipoTramite.DJEELL ||
        (tipo.codigo === TipoTramite.DJG && conEfluentesLiquidos)) &&
      plantasTratamiento.length > 0
    ) {
      return schema
        .of(ResiduoTratamientoSchema)
        .min(1, "errors.tramite.residuosTratamiento.min")
        .default([]);
    } else {
      return schema.of(ResiduoTratamientoSchema).min(0).default([]);
    }
  } else {
    return schema.optional();
  }
}

export function createConTratamientoRSUInternoField(
  [tipo, conResiduosSolidosUrbanos, establecimiento],
  schema,
) {
  if ([TipoTramite.DJRR, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    (tipo.codigo === TipoTramite.DJRR &&
      establecimiento?.conResiduosSolidosUrbanos) ||
    (tipo.codigo === TipoTramite.DJG && conResiduosSolidosUrbanos)
  ) {
    return schema
      .required("errors.tramite.conTratamientoRSUInterno.required")
      .default(false);
  } else {
    return schema.nullable().default(false);
  }
}

export function createEsGeneradorRSUEspecialesField(
  [tipo, conResiduosSolidosUrbanos, establecimiento],
  schema,
) {
  if ([TipoTramite.DJRR, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    (tipo.codigo === TipoTramite.DJRR &&
      establecimiento?.conResiduosSolidosUrbanos) ||
    (tipo.codigo === TipoTramite.DJG && conResiduosSolidosUrbanos)
  ) {
    return schema
      .required("errors.tramite.esGeneradorRSUEspeciales.required")
      .default(false);
  } else {
    return schema.nullable().default(false);
  }
}

export function createRegistroRSUEspecialesField(
  [tipo, conResiduosSolidosUrbanos, esGeneradorRSUEspeciales, establecimiento],
  schema,
) {
  if ([TipoTramite.DJRR, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    (tipo.codigo === TipoTramite.DJRR &&
      establecimiento?.conResiduosSolidosUrbanos &&
      esGeneradorRSUEspeciales) ||
    (tipo.codigo === TipoTramite.DJG &&
      conResiduosSolidosUrbanos &&
      esGeneradorRSUEspeciales)
  ) {
    return schema.required("errors.tramite.registroRSUEspeciales.required");
  } else {
    return schema.nullable().default(null);
  }
}

export function createDisponeRSUCEAMSEField(
  [tipo, conResiduosSolidosUrbanos, establecimiento],
  schema,
) {
  if ([TipoTramite.DJRR, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    (tipo.codigo === TipoTramite.DJRR &&
      establecimiento?.conResiduosSolidosUrbanos) ||
    (tipo.codigo === TipoTramite.DJG && conResiduosSolidosUrbanos)
  ) {
    return schema.required("errors.tramite.disponeRSUCEAMSE").default(false);
  } else {
    return schema.nullable().default(false);
  }
}

export function createRegistroAltaCEAMSEField(
  [tipo, conResiduosSolidosUrbanos, disponeRSUCEAMSE, establecimiento],
  schema,
) {
  if ([TipoTramite.DJRR, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional().nullable();
  if (
    ((tipo.codigo === TipoTramite.DJRR &&
      establecimiento.conResiduosSolidosUrbanos) ||
      (tipo.codigo === TipoTramite.DJG && conResiduosSolidosUrbanos)) &&
    disponeRSUCEAMSE
  ) {
    return schema
      .required("errors.tramite.registroAltaCEAMSE.required")
      .nonNullable("errors.tramite.registroAltaCEAMSE.required")
      .max(20, "errors.tramite.registroAltaCEAMSE.max")
      .default(null);
  } else {
    return schema.nullable().default(null);
  }
}

export function createDisposicionRSU(
  [tipo, conResiduosSolidosUrbanos, disponeRSUCEAMSE, establecimiento],
  schema,
) {
  if ([TipoTramite.DJRR, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    ((tipo.codigo === TipoTramite.DJRR &&
      establecimiento?.conResiduosSolidosUrbanos) ||
      (tipo.codigo === TipoTramite.DJG && conResiduosSolidosUrbanos)) &&
    !disponeRSUCEAMSE
  ) {
    return schema
      .max(1024, "errors.tramite.disposicionRSU.required")
      .required("errors.tramite.disposicionRSU.required")
      .default(null);
  } else {
    return schema.nullable().default(null);
  }
}

export function createDisposicionCertificadosRSU(
  [
    tipo,
    conResiduosSolidosUrbanos,
    disponeRSUCEAMSE,
    domicilio,
    establecimiento,
  ],
  schema,
) {
  if ([TipoTramite.DJRR, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    ((tipo.codigo === TipoTramite.DJG &&
      conResiduosSolidosUrbanos &&
      domicilio.provincia === "O6") ||
      (tipo.codigo === TipoTramite.DJRR &&
        establecimiento.domicilio.provincia === "06")) &&
    !disponeRSUCEAMSE
  ) {
    return schema
      .max(20, "errors.tramite.disposicionCertificadosRSU.required")
      .required("errors.disposicionCertificadosRSU.required")
      .default(null);
  } else {
    return schema.nullable().default(null);
  }
}

export function createTratamientoRSU(
  [tipo, conResiduosSolidosUrbanos, conTratamientoRSUInterno, establecimiento],
  schema,
) {
  if ([TipoTramite.DJRR, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    ((tipo.codigo === TipoTramite.DJRR &&
      establecimiento?.conResiduosSolidosUrbanos) ||
      (tipo.codigo === TipoTramite.DJG && conResiduosSolidosUrbanos)) &&
    conTratamientoRSUInterno
  ) {
    return schema
      .min(1, "errors.tramite.tratamientosRSU.min")
      .required("errors.tramite.tratamientosRSU.required")
      .default([]);
  } else {
    return schema
      .min(0)
      .required("errors.tramite.tratamientosRSU.required")
      .default([]);
  }
}

export function createResiduosSolidosUrbanosField(
  [tipo, conResiduosSolidosUrbanos, establecimiento],
  schema,
) {
  if ([TipoTramite.DJRR, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    (tipo.codigo === TipoTramite.DJRR &&
      establecimiento.conResiduosSolidosUrbanos) ||
    (tipo.codigo === TipoTramite.DJG && conResiduosSolidosUrbanos)
  ) {
    return schema
      .of(ResiduoSolidoUrbanoSchema)
      .min(1, "errors.tramite.residuosSolidosUrbanos.min")
      .required("errors.tramite.residuosSolidosUrbanos.required")
      .default([]);
  } else {
    return schema
      .of(ResiduoSolidoUrbanoSchema)
      .min(0)
      .required("errors.tramite.residuosSolidosUrbanos.required")
      .default([]);
  }
}

export function createRegistroResiduosPeligrososField(
  [tipo, conResiduosPeligrosos, establecimiento],
  schema,
) {
  if ([TipoTramite.DJRR, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    (tipo.codigo === TipoTramite.DJRR &&
      establecimiento?.conResiduosPeligrosos) ||
    (tipo.codigo === TipoTramite.DJG && conResiduosPeligrosos)
  ) {
    return schema
      .max(20, "errors.tramite.registroResiduosPeligrosos.max")
      .required("errors.tramite.registroResiduosPeligrosos.required");
  } else {
    return schema.nullable();
  }
}

export function createResiduosPeligrososField(
  [tipo, conResiduosPeligrosos, establecimiento],
  schema,
) {
  if ([TipoTramite.DJRR, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    (tipo.codigo === TipoTramite.DJRR &&
      establecimiento?.conResiduosPeligrosos) ||
    (tipo.codigo === TipoTramite.DJG && conResiduosPeligrosos)
  ) {
    return schema
      .of(ResiduoPeligrosoSchema)
      .min(1, "errors.tramite.residuosPeligrosos.min")
      .required("errors.tramite.residuosPeligrosos.required")
      .default([]);
  } else {
    return schema
      .of(ResiduoPeligrosoSchema)
      .min(0)
      .required("errors.tramite.residuosPeligrosos.required")
      .default([]);
  }
}

export function createRegistroResiduosPatogenicosField(
  [tipo, conResiduosPatogenicos, establecimiento],
  schema,
) {
  if ([TipoTramite.DJRR, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    (tipo.codigo === TipoTramite.DJRR &&
      establecimiento?.conResiduosPatogenicos) ||
    (tipo.codigo === TipoTramite.DJG && conResiduosPatogenicos)
  ) {
    return schema
      .max(20, "errors.tramite.registroResiduosPatogenicos.max")
      .required("errors.tramite.registroResiduosPatogenicos.required");
  } else {
    return schema.nullable();
  }
}

export function createResiduosPatogenicosField(
  [tipo, conResiduosPatogenicos, establecimiento],
  schema,
) {
  if ([TipoTramite.DJRR, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    (tipo.codigo === TipoTramite.DJRR &&
      establecimiento?.conResiduosPatogenicos) ||
    (tipo.codigo === TipoTramite.DJG && conResiduosPatogenicos)
  ) {
    return schema
      .of(ResiduoPatogenicoSchema)
      .min(1, "errors.tramite.residuosPatogenicos.min")
      .required("errors.tramite.residuosPatogenicos.required")
      .default([]);
  } else {
    return schema
      .of(ResiduoPatogenicoSchema)
      .min(0)
      .required("errors.tramite.residuosPatogenicos.required")
      .default([]);
  }
}

export function createRegistroEquiposPCBField(
  [tipo, conEquiposPCB, establecimiento],
  schema,
) {
  if ([TipoTramite.DJRR, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    (tipo.codigo === TipoTramite.DJRR && establecimiento?.conEquiposPCB) ||
    (tipo.codigo === TipoTramite.DJG && conEquiposPCB)
  ) {
    return schema
      .max(20, "errors.tramite.registroEquiposPCB.max")
      .required("errors.tramite.registroEquiposPCB.required")
      .default(null);
  } else {
    return schema.nullable().default(null);
  }
}

export function createCertificadoLibrePCB(
  [tipo, conEquiposPCB, establecimiento],
  schema,
) {
  if ([TipoTramite.DJRR, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    (tipo.codigo === TipoTramite.DJRR && establecimiento?.conEquiposPCB) ||
    (tipo.codigo === TipoTramite.DJG && conEquiposPCB)
  ) {
    return schema
      .required("errors.tramite.conCertificadoLibrePCB.required")
      .default(false);
  } else {
    return schema.nullable().default(false);
  }
}

export function createConRegistroEmisionesGaseosasField(
  [tipo, conEmisionesGaseosas],
  schema,
) {
  if ([TipoTramite.DJEEGG, TipoTramite.DJG].indexOf(tipo.codigo) >= 0) {
    return schema
      .required("errors.tramite.conRegistroEmisionesGaseosas.required")
      .default(false);
  } else {
    return schema.optional();
  }
}

export function createRegistroEmisionesGaseosasField(
  [tipo, conEmisionesGaseosas, conRegistroEmisionesGaseosas],
  schema,
) {
  if ([TipoTramite.DJEEGG, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    (tipo.codigo === TipoTramite.DJEEGG ||
      (tipo.codigo === TipoTramite.DJG && conEmisionesGaseosas)) &&
    conRegistroEmisionesGaseosas
  ) {
    return schema
      .max(20, "errors.tramite.registroEmisionesGaseosas.max")
      .required("errors.tramite.registroEmisionesGaseosas.required")
      .default(null);
  } else {
    return schema.nullable().default(null);
  }
}

export function createConMonitoreoAireField(
  [tipo, conEmisionesGaseosas],
  schema,
) {
  if ([TipoTramite.DJEEGG, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    tipo.codigo === TipoTramite.DJRR ||
    (tipo.codigo === TipoTramite.DJG && conEmisionesGaseosas)
  ) {
    return schema
      .required("errors.tramite.conMonitoreoAire.required")
      .default(false);
  } else {
    return schema.nullable().default(false);
  }
}

export function createMonitoreoAireField(
  [tipo, conEmisionesGaseosas, conMonitoreoAire],
  schema,
) {
  if ([TipoTramite.DJEEGG, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    (tipo.codigo === TipoTramite.DJEEGG ||
      (tipo.codigo === TipoTramite.DJG && conEmisionesGaseosas)) &&
    conMonitoreoAire
  ) {
    return schema
      .concat(MonitoreoAireSchema)
      .typeError("errors.tramite.monitoreoAire.required")
      .required("errors.tramite.monitoreoAire.required")
      .default(MonitoreoAireSchema.cast(undefined, { assert: false }));
  } else {
    return schema.concat(MonitoreoAireSchema).nullable().default(null);
  }
}

export function transformConEmisionesComponentesNaturalesField(
  value,
  original,
  context,
) {
  if (!!value && value === null) {
    return false;
  }
  return value;
}

export function createConEmisionesComponentesNaturalesField(
  [tipo, conEmisionesGaseosas, action],
  schema,
) {
  if ([TipoTramite.DJEEGG, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    tipo.codigo === TipoTramite.DJEEGG ||
    (tipo.codigo === TipoTramite.DJG && conEmisionesGaseosas)
  ) {
    return schema
      .required("errors.tramite.conEmisionesComponentesNaturales.required")
      .transform(
        (action === ACCION_ACTUALIZAR &&
          transformConEmisionesComponentesNaturalesField) ||
          passThrough,
      )
      .default(false);
  } else {
    return schema.nullable().default(false);
  }
}

export function transformConEmisionesCombustionHidrocarburosField(
  value,
  original,
  context,
) {
  if (!!value && value === null) {
    return false;
  }
  return value;
}

export function createConEmisionesCombustionHidrocarburosField(
  [tipo, conEmisionesGaseosas, action],
  schema,
) {
  if ([TipoTramite.DJEEGG, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    tipo.codigo === TipoTramite.DJEEGG ||
    (tipo.codigo === TipoTramite.DJG && conEmisionesGaseosas)
  ) {
    return schema
      .required("errors.tramite.conEmisionesCombustionHidrocarburos.required")
      .transform(
        (action === ACCION_ACTUALIZAR &&
          transformConEmisionesCombustionHidrocarburosField) ||
          passThrough,
      )
      .default(false);
  } else {
    return schema.nullable().default(false);
  }
}

export function transformConEmisionesOtrosGasesField(value, original, context) {
  if (!!value && value === null) {
    return false;
  }
  return value;
}

export function createConEmisionesOtrosGasesField(
  [tipo, conEmisionesGaseosas, action],
  schema,
) {
  if ([TipoTramite.DJEEGG, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional().strip();
  if (
    tipo.codigo === TipoTramite.DJEEGG ||
    (tipo.codigo === TipoTramite.DJG && conEmisionesGaseosas)
  ) {
    return schema
      .required("errors.tramite.conEmisionesOtrosGases.required")
      .transform(
        (action === ACCION_ACTUALIZAR &&
          transformConEmisionesOtrosGasesField) ||
          passThrough,
      )
      .default(false);
  } else {
    return schema.nullable().default(false);
  }
}

export function createConChimeneasField([tipo, conEmisionesGaseosas], schema) {
  if ([TipoTramite.DJEEGG, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    tipo.codigo === TipoTramite.DJEEGG ||
    (tipo.codigo === TipoTramite.DJG && conEmisionesGaseosas)
  ) {
    return schema
      .required("errors.tramite.conChimeneas.required")
      .default(false);
  } else {
    return schema.nullable().default(false);
  }
}

export function createChimeneasField(
  [tipo, conEmisionesGaseosas, conChimeneas],
  schema,
) {
  if ([TipoTramite.DJEEGG, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    (tipo.codigo === TipoTramite.DJEEGG ||
      (tipo.codigo === TipoTramite.DJG && conEmisionesGaseosas)) &&
    conChimeneas
  ) {
    return schema
      .of(DuctoSchema)
      .min(1, "errors.tramite.chimeneas.min")
      .required("errors.tramite.chimeneas.required")
      .default([]);
  } else {
    return schema
      .of(DuctoSchema)
      .min(0)
      .required("errors.tramite.chimeneas.required")
      .default([]);
  }
}

export function createConEvaporacionLiquidosField(
  [tipo, conEmisionesGaseosas],
  schema,
) {
  if ([TipoTramite.DJEEGG, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    tipo.codigo === TipoTramite.DJEEGG ||
    (tipo.codigo === TipoTramite.DJG && conEmisionesGaseosas)
  ) {
    return schema
      .required("errors.tramite.conEvaporacionLiquidos.required")
      .default(false);
  } else {
    return schema.nullable().default(false);
  }
}

export function createConMovimientoLiquidosField(
  [tipo, conEmisionesGaseosas],
  schema,
) {
  if ([TipoTramite.DJEEGG, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    tipo.codigo === TipoTramite.DJEEGG ||
    (tipo.codigo === TipoTramite.DJG && conEmisionesGaseosas)
  ) {
    return schema
      .required("errors.tramite.conMovimientoLiquidos.required")
      .default(false);
  } else {
    return schema.nullable().default(false);
  }
}

export function createConAcopioLiquidosField(
  [tipo, conEmisionesGaseosas],
  schema,
) {
  if ([TipoTramite.DJEEGG, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    tipo.codigo === TipoTramite.DJEEGG ||
    (tipo.codigo === TipoTramite.DJG && conEmisionesGaseosas)
  ) {
    return schema
      .required("errors.tramite.conAcopioLiquidos.required")
      .default(false);
  } else {
    return schema.nullable().default(false);
  }
}

export function createTanquesAcopioLiquidosField(
  [tipo, conEmisionesGaseosas, conAcopioLiquidos],
  schema,
) {
  if ([TipoTramite.DJEEGG, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    (tipo.codigo === TipoTramite.DJEEGG ||
      (tipo.codigo === TipoTramite.DJG && conEmisionesGaseosas)) &&
    conAcopioLiquidos
  ) {
    return schema
      .of(TanqueAcopioLiquidoSchema)
      .min(1, "errors.tramite.tanquesAcopioLiquido.min")
      .required("errors.tramite.tanquesAcopioLiquido.required")
      .default([]);
  } else {
    return schema.of(TanqueAcopioLiquidoSchema).min(0).default([]);
  }
}

export function createConSublimacionSolidosField(
  [tipo, conEmisionesGaseosas],
  schema,
) {
  if ([TipoTramite.DJEEGG, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    tipo.codigo === TipoTramite.DJEEGG ||
    (tipo.codigo === TipoTramite.DJG && conEmisionesGaseosas)
  ) {
    return schema
      .required("errors.tramite.conSublimacionSolidos.required")
      .default(false);
  } else {
    return schema.nullable().default(false);
  }
}

export function createConSolidosGranularesField(
  [tipo, conEmisionesGaseosas],
  schema,
) {
  if ([TipoTramite.DJEEGG, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    tipo.codigo === TipoTramite.DJEEGG ||
    (tipo.codigo === TipoTramite.DJG && conEmisionesGaseosas)
  ) {
    return schema
      .required("errors.tramite.conSolidosGranulares.required")
      .default(false);
  } else {
    return schema.nullable().default(false);
  }
}

export function createConAcopioSolidosGranelField(
  [tipo, conEmisionesGaseosas],
  schema,
) {
  if ([TipoTramite.DJEEGG, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    tipo.codigo === TipoTramite.DJEEGG ||
    (tipo.codigo === TipoTramite.DJG && conEmisionesGaseosas)
  ) {
    return schema
      .required("errors.tramite.conAcopioSolidosGranel.required")
      .default(false);
  } else {
    return schema.nullable().default(false);
  }
}

export function createConAcopioSolidos1000m2Field(
  [tipo, conEmisionesGaseosas],
  schema,
) {
  if ([TipoTramite.DJEEGG, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    tipo.codigo === TipoTramite.DJEEGG ||
    (tipo.codigo === TipoTramite.DJG && conEmisionesGaseosas)
  ) {
    return schema
      .required("errors.tramite.conAcopioSolidos1000m2.required")
      .default(false);
  } else {
    return schema.nullable().default(false);
  }
}

export function createAreasAcopioSolidosField(
  [
    tipo,
    conEmisionesGaseosas,
    conSolidosGranulares,
    conSublimacionSolidos,
    conAcopioSolidosGranel,
  ],
  schema,
) {
  if ([TipoTramite.DJEEGG, TipoTramite.DJG].indexOf(tipo.codigo) < 0)
    return schema.optional();
  if (
    (tipo.codigo === TipoTramite.DJEEGG ||
      (tipo.codigo === TipoTramite.DJG && conEmisionesGaseosas)) &&
    (conSolidosGranulares || conSublimacionSolidos || conAcopioSolidosGranel)
  ) {
    return schema
      .of(AreaAcopioSolidosSchema)
      .min(1, "errors.tramite.areasAcopioSolidos.min")
      .required("errors.tramite.areasAcopioSolidos.required")
      .default([]);
  } else {
    return schema
      .of(AreaAcopioSolidosSchema)
      .min(0)
      .required("errors.tramite.areasAcopioSolidos.required")
      .default([]);
  }
}

export function createAdjuntosField([tipo, estado], schema) {
  if (
    tipo?.codigo === TipoTramite.DJG &&
    estado?.codigo === EstadoTramite.FINALIZADO
  ) {
    return schema.of(DocumentoAdjuntoSchema);
  } else {
    return schema.optional();
  }
}

export function transofrmConexionRedField(value, original, context) {
  if (!!value && value !== null && this.isType(value)) {
    return value.caudalMedio === null &&
      value.caudalPico === null &&
      value.prestador === null
      ? null
      : value;
  }
  return value;
}

export function prepararTramite(tramite) {
  const preparado = TramiteSchema.cast(tramite, { assert: false });
  if (
    !!preparado.representanteLegal &&
    preparado.representanteLegal?.nombre === "" &&
    preparado.representanteLegal?.documento === "" &&
    preparado.representanteLegal?.cargo === "" &&
    preparado.representanteLegal?.telefono === "" &&
    preparado.representanteLegal?.correoElectronico === ""
  ) {
    preparado.representanteLegal = null;
  }
  if (
    preparado?.representanteTecnico?.matricula?.ente === "" &&
    preparado.representanteTecnico?.matricula?.numero === ""
  ) {
    preparado.representanteTecnico.matricula = null;
  }
  if (
    !!preparado.representanteTecnico &&
    preparado.representanteTecnico?.nombre === "" &&
    preparado.representanteTecnico?.documento === "" &&
    preparado.representanteTecnico?.cargo === "" &&
    preparado.representanteTecnico?.telefono === "" &&
    preparado.representanteTecnico?.correoElectronico === "" &&
    preparado.representanteTecnico?.matricula === null
  ) {
    preparado.representanteTecnico = null;
  }
  if (
    !!preparado.seguroAmbiental &&
    preparado.seguroAmbiental.poliza === "" &&
    preparado.seguroAmbiental.aseguradora === "" &&
    preparado.seguroAmbiental.importe === 0 &&
    !preparado.seguroAmbiental.vencimiento
  ) {
    preparado.seguroAmbiental = null;
  }
  if (
    !preparado.consumoEnergiaAlternativa?.unidad &&
    [TipoTramite.DJA, TipoTramite.DJG].indexOf(preparado.tipo?.codigo) >= 0
  ) {
    preparado.consumoEnergiaAlternativa = null;
  }
  if (
    !preparado.tratamientoIndividual?.unidad &&
    ((preparado.tipo?.codigo === TipoTramite.DJG &&
      preparado.conEfluentesLiquidos) ||
      preparado.tipo.codigo === TipoTramite.DJEELL)
  ) {
    preparado.tratamientoIndividual = null;
  }
  return preparado;
}

export function withEfluentesLiquidos(tramiteForm, value) {
  tramiteForm.setValues(
    TramiteSchema.cast(
      {
        ...tramiteForm.values,
        ...{
          conEfluentesLiquidos: value,
          fuentesEfluentesLiquidos: undefined,
          tratamientoIndividual: undefined,
          plantasTratamiento: undefined,
          caracterizacionEfluenteCrudo: undefined,
          lineasVertido: undefined,
          conTratamientoExterno: undefined,
          tratamientosExternos: undefined,
          reusoTratamiento: undefined,
          residuosTratamiento: undefined,
        },
      },
      { assert: false },
    ),
  );
}

export function withResiduosSolidosUrbanos(tramiteForm, value) {
  tramiteForm.setValues(
    TramiteSchema.cast(
      {
        ...tramiteForm.values,
        ...{
          conResiduosSolidosUrbanos: value,
          conTratamientoRSUInterno: undefined,
          esGeneradorRSUEspeciales: undefined,
          registroRSUEspeciales: undefined,
          disponeRSUCEAMSE: undefined,
          registroAltaCEAMSE: undefined,
          disposicionRSU: undefined,
          disposicionCertificadosRSU: undefined,
          tratamientosRSU: undefined,
          residuosSolidosUrbanos: undefined,
        },
      },
      { assert: false },
    ),
  );
}

export function withResiduosPeligrosos(tramiteForm, value) {
  tramiteForm.setValues(
    TramiteSchema.cast(
      {
        ...tramiteForm.values,
        ...{
          conResiduosPeligrosos: value,
          registroResiduosPeligrosos: undefined,
          residuosPeligrosos: undefined,
        },
      },
      { assert: false },
    ),
  );
}

export function withResiduosPatogenicos(tramiteForm, value) {
  tramiteForm.setValues(
    TramiteSchema.cast(
      {
        ...tramiteForm.values,
        ...{
          conResiduosPatogenicos: value,
          registroResiduosPatogenicos: undefined,
          residuosPatogenicos: undefined,
        },
      },
      { assert: false },
    ),
  );
}

export function withEquiposPCB(tramiteForm, value) {
  tramiteForm.setValues(
    TramiteSchema.cast(
      {
        ...tramiteForm.values,
        ...{
          conEquiposPCB: value,
          registroEquiposPCB: undefined,
          conCertificadoLibrePCB: undefined,
        },
      },
      { assert: false },
    ),
  );
}

export function withEmisionesGaseosas(tramiteForm, value) {
  tramiteForm.setValues(
    TramiteSchema.cast(
      {
        ...tramiteForm.values,
        ...{
          conEmisionesGaseosas: value,
          conRegistroEmisionesGaseosas: undefined,
          registroEmisionesGaseosas: undefined,
          conMonitoreoAire: undefined,
          monitoreoAire: undefined,
          conEmisionesComponentesNaturales: undefined,
          conEmisionesCombustionHidrocarburos: undefined,
          conEmisionesOtrosGases: undefined,
          conChimeneas: undefined,
          chimeneas: undefined,
          conEvaporacionLiquidos: undefined,
          conMovimientoLiquidos: undefined,
          conAcopioLiquidos: undefined,
          tanquesAcopioLiquidos: undefined,
          conSublimacionSolidos: undefined,
          conSolidosGranulares: undefined,
          conAcopioSolidosGranel: undefined,
          conAcopioSolidos1000m2: undefined,
          areasAcopioSolidos: undefined,
        },
      },
      { assert: false },
    ),
  );
}
